import { render, staticRenderFns } from "./ViewMovie.vue?vue&type=template&id=4d5b4334&scoped=true"
import script from "./ViewMovie.vue?vue&type=script&lang=js"
export * from "./ViewMovie.vue?vue&type=script&lang=js"
import style0 from "./ViewMovie.vue?vue&type=style&index=0&id=4d5b4334&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5b4334",
  null
  
)

export default component.exports